import store from 'store'
import md5 from 'js-md5'
import { model } from 'service/model'
import xhr from 'service'
import url from './hostconfig'
import router from '../router'
import Vue from 'vue'

const bus = new Vue() // bus传值

let type = ["Boolean", "Number", "String", "Function", "Array", "Date", "RegExp", "Object", "Error"];

let getOwnPropertySymbols = Object.getOwnPropertySymbols;
let hasOwnProperty = Object.prototype.hasOwnProperty;
let propIsEnumerable = Object.prototype.propertyIsEnumerable;

let is = {};

for (let i = 0; i < type.length; i++) {
    (function (k) {
        is[type[k]] = function (obj) {
            return Object.prototype.toString.call(obj) === '[object ' + type[k] + ']';
        };
    })(i);
}

const _stringify = function (val) {
    let returnVal = is.Object(val) ? JSON.stringify(val) : val;
    return returnVal;
}

const _parse = function (val) {
    let returnVal = ''
    try {
        returnVal = JSON.parse(val);
    } catch (e) { }
    returnVal = is.Object(returnVal) ? returnVal : val;
    return returnVal;
}

const returnSourceList = function (result, arr) {
    arr.map(item => {
        result[item.id] = item.channel_name
        if (item.child && item.child.length) {
            returnSourceList(result, item.child)
        }
    })
}
/* 数据扁平化 */
const treeToList = function (tree) {
    var queen = []
    var out = []
    queen = queen.concat(tree)
    while (queen.length) {
        var first = queen.shift()
        if (first.child) {
            queen = queen.concat(first.child)
            delete first['child']
        }
        out.push(first)
    }
    return out
}

const ruturnDepartmentList = function (result, arr) {
    arr.map(item => {
        result[item.id] = item.dep_name
        if (item.child && item.child.length) {
            ruturnDepartmentList(result, item.child)
        }
    })
}

const optimizeCb = function (func, context, argCount) {
    if (context === void 0) return func;
    return function (value, index, collection) {
        return func.call(context, value, index, collection);
    }
}

const isArrayLike = function (collection) {
    let length = collection == null ? void 0 : collection.length;
    return typeof length == 'number' && length >= 0 && length <= 1e4;
}

const keys = function (object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

const toObject = function (val) {
    if (val === null || val === undefined) {
        throw new TypeError('Object.assign cannot be called with null or undefined');
    }

    return Object(val);
}

const shouldUseNative = function () {
    try {
        if (!Object.assign) {
            return false;
        }

        // Detect buggy property enumeration order in older V8 versions.
        let test1 = new String('abc');
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') {
            return false;
        }

        let test2 = {};
        for (let i = 0; i < 10; i++) {
            test2['_' + String.fromCharCode(i)] = i;
        }
        let order2 = Object.getOwnPropertyNames(test2).map(function (n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') {
            return false;
        }

        let test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !==
            'abcdefghijklmnopqrst') {
            return false;
        }

        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}

const padLeftZero = function (str) {
    if (str.length > 2) {
        return ('000' + str).substr(str.length);
    }
    return ('00' + str).substr(str.length);
}

/**
 * 遍历 collection
 * @param  {[Object|Array]}  obj   [collection]
 * @param  {[Function]}  iteratee  [迭代函数]
 * @return {[Object|Array]}         [collection]
 */
const each = function (obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    let i, length;
    if (isArrayLike(obj) && obj.length) {
        for (i = 0, length = obj.length; i < length; i++) {
            iteratee(obj[i], i, obj);
        }
    } else {
        let i = 0;
        for (let key in obj) {
            iteratee(obj[key], key, i++, obj);
        }
    }
    return obj;
}

const merge = function () {
    return shouldUseNative() ? Object.assign : function (target, source) {
        let from;
        let to = toObject(target);
        let symbols;

        for (let s = 1; s < arguments.length; s++) {
            from = Object(arguments[s]);

            for (let key in from) {
                if (hasOwnProperty.call(from, key)) {
                    to[key] = from[key];
                }
            }

            if (getOwnPropertySymbols) {
                symbols = getOwnPropertySymbols(from);
                for (let i = 0; i < symbols.length; i++) {
                    if (propIsEnumerable.call(from, symbols[i])) {
                        to[symbols[i]] = from[symbols[i]];
                    }
                }
            }
        }
        return to;
    }
}()

const formatDate = function (date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
}

/**
 * 用时计算
 * @param  intDiff 开始时间戳
 */
const timer = function (intDiff, fmt) {
    let _start = new Date(intDiff), _end = new Date();
    let dateDiff = _end.getTime() - _start.getTime() //时间差的毫秒数
    let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
    let leave1 = dateDiff % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
    let hours = Math.floor(leave1 / (3600 * 1000))//计算出小时数
    //计算相差分钟数
    let leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
    let minutes = Math.floor(leave2 / (60 * 1000))//计算相差分钟数
    //计算相差秒数
    let leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
    let seconds = Math.round(leave3 / 1000)
    let o = {
        'h+': (hours + dayDiff * 24),
        'm+': minutes,
        's+': seconds
    };
    if (fmt) {
        for (let k in o) {
            if (new RegExp(`(${k})`).test(fmt)) {
                let str = o[k] + '';
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
            }
        }
        return fmt
    } else {
        let str = `${dayDiff}天 ${hours}小时 ${seconds > 59 ? minutes++ : minutes} 分钟${seconds == 60 ? 0 : seconds} 秒`
        return str
    }
}

const firstCurDate = function () { //本月1号到当前日期
    return [formatDate((new Date((new Date()).setDate(1))), 'yyyy-MM-dd'), formatDate((new Date()), 'yyyy-MM-dd')]
}
const dateTypeValue = function (params) { //昨天天
    if (params == 'yesterday') {
        return formatDate(new Date(Date.now() - 3600 * 24 * 1000), 'yyyy-MM-dd')
    }
    if (params == 'month') {
        return formatDate(new Date(Date.now()), 'yyyy-MM')
    }
    if (params == 'year') {
        return formatDate(new Date(Date.now()), 'yyyy')
    }
    if (params == 'day') {
        return formatDate(new Date(Date.now()), 'yyyy-MM-dd')
    }
    if (params == 'fullMonth') {
        let fullYear = new Date().getFullYear(),
            fullMonth = new Date().getMonth()
        return [formatDate((new Date((new Date()).setDate(1))), 'yyyy-MM-dd'), formatDate((new Date(fullYear, fullMonth + 1, 0)), 'yyyy-MM-dd')]
    }
    if (params == 'week') {
        /* let d1 = new Date(),d2 = new Date();
        d2.setMonth(0)
        d2.setDate(1)
        let rq = d1-d2;
        let s1 = Math.ceil(rq/(24*60*60*1000))
        let s2 = Math.ceil(s1/7) */
        return new Date(Date.now())
    }
}

// 设置缓存
const setStore = function (key, value) {
    let val = _stringify(value);
    localStorage.setItem(key, val);
}

// 获取缓存
const getStore = function (key) {
    return localStorage.getItem(key) && _parse(localStorage.getItem(key));
}

// 删除缓存
const delItem = function (key) {
    delete localStorage[key];
}

// 清空缓存
const clearStore = function () {
    for (var lsName in localStorage) {
        if (!['userLog', 'preTime', 'roleCache', 'constantCache', 'version'].includes(lsName)) {
            localStorage.removeItem(lsName);
        }
    }
    //localStorage.clear();
    return true
}

/**
 * 上传文件接口
 */
const getUpdateUrl = function () {
    return url + '/' + model.uploadImg.url
}
const getExcelUrl = function () {
    return url + '/' + model.schoolTaskImport.url
}

/**
 * 对象是否为空
 */
const isEmptyObject = function (value) {
    if (is.Object(value)) {
        for (let val in value) {
            if (val) {
                return false
            }
        }
    }
    return true;
}

const pickerAfterToday = function () {
    return {
        disabledDate (time) {
            return time.getTime() < Date.now() - 8.64e7;
        }
    }
}

// 获取权限
const getAction = function (key) {
    let { path } = router.currentRoute
    if (store.getters['auth/roleCacheData'].rights[path]) {
        let _role_permission_html_module = store.getters['auth/roleCacheData'].rights[path].role_permission_html_module
        return _role_permission_html_module ? _role_permission_html_module.includes(key) : false
    } else if (router.history.current.meta.index) {
        let current = router.history.current.meta.index
        let _role_permission_html_module = store.getters['auth/roleCacheData'].rights[current].role_permission_html_module
        return _role_permission_html_module ? _role_permission_html_module.includes(key) : false
    }
}
// 获取权限数组
const getActions = function () {
    let { path } = router.currentRoute
    if (store.getters['auth/roleCacheData'].rights[path]) {
        if (!store.getters['auth/roleCacheData'].rights[path]) return []
        let _role_permission_html_module = store.getters['auth/roleCacheData'].rights[path].role_permission_html_module
        return _role_permission_html_module
    } else if (router.history.current.meta.index) {
        let current = router.history.current.meta.index
        let _role_permission_html_module = store.getters['auth/roleCacheData'].rights[current].role_permission_html_module
        return _role_permission_html_module
    }
}

const getRole_permission = function () {
    return store.getters['auth/roleCacheData'].role_permission_ids
}
// 角色路由表
const getRole_route = function () {
    return store.getters['auth/roleCacheData'].rights || {}
}

const getAccess_token = function () {
    return store.getters['auth/user'].access_token
}

const getDepartmentChannel = function () {
    let user = deepCopy(store.getters['auth/user'])
    let departmentChannel = user.departmentChannel
    if (typeof departmentChannel == 'object') {
        return departmentChannel
    }

    let trempChannel = store.getters['auth/constantCacheData'].channel
    let result = []
    if (!departmentChannel) {
        result = trempChannel
    } else {
        let tempDepartmentChannel = departmentChannel.split(',')
        result = trempChannel.filter(item => {
            return tempDepartmentChannel.indexOf(String(item.channel_type)) > -1
        })
    }

    user.departmentChannel = result
    store.commit('auth/SETUSER', user)
    localStorage.setItem('user', JSON.stringify(user));
    return result
}

/*
对象拷贝
*/
const deepCopy = function (obj) {
    let objClone = Array.isArray(obj) ? [] : {};
    if (obj && typeof obj === "object") {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (obj[key] && typeof obj[key] === "object") {
                    objClone[key] = deepCopy(obj[key]);
                } else {
                    objClone[key] = obj[key];
                }
            }
        }
    }
    return objClone;
}

/*
根据key获从取常量列表arr获取其名称
*/
const valueToNameArr = {}
const valueToName = function (groupName, key, objName) {
    if (!valueToNameArr[objName]) {
        let arr = treeToList(JSON.parse(JSON.stringify(getConstantByKeyword(groupName))))
        if (JSON.stringify(arr) != '{}') {
            let result = {}
            if (objName == 'channelList') {
                arr.map(item => {
                    result[item.id] = item.channel_name
                })
            } else if (objName == 'departmentList') {
                arr.map(item => {
                    result[item.id] = item.dep_name
                })
            } else if (objName == 'gradeList') {
                arr.map(item => {
                    result[item.id] = item.grade_name
                })
            } else if (objName == 'payList') {
                arr.map(item => {
                    result[item.id] = item.pay_name
                })
            } else if (objName == 'prductTypeList') {
                arr.map(item => {
                    result[item.product_type_key] = item.type_name
                })
            } else if (objName == 'prductTypeIDList') {
                arr.map(item => {
                    result[item.id] = item.type_name
                })
            } else if (objName == 'contractTemplateList') {
                arr.map(item => {
                    result[item.id] = item.template_name
                })
            } else if (objName == 'subjectList') {
                arr.map(item => {
                    result[item.id] = item.subject_name
                })
            } else {
                arr.map(item => {
                    result[item.item_value] = item.item_name
                })
            }
            valueToNameArr[objName] = result
        }
    }
    return valueToNameArr[objName][key] || '--'
}

const getToken = function (...arg) {
    Date.prototype.Format = function (fmt) {
        let o = {
            "M+": this.getMonth() + 1, //月份
            "d+": this.getDate(), //日
            "h+": this.getHours(), //小时
            "m+": this.getMinutes(), //分
            "s+": this.getSeconds(), //秒
            "q+": Math.floor((this.getMonth() + 3) / 3), //季度
            "S": this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    }
    let date = new Date().Format('yyyyMMdd');
    return md5((arg.length > 0 ? arg[0] : '22bc0e4e69fd11e8889700005b189cc8') + '-' + date)
}

const codeCountdown = function (Obj, text, count, cb) {
    let num = count || 60
    let timer = setInterval(function () {
        num--
        if (text) {
            Obj.innerHTML = '<span>' + num + text + '</span>';
        } else {
            Obj.innerHTML = '<span>' + num + ' 秒后重新获取' + '</span>';
        }
        Obj.disabled = ' disabled';
        Obj.style.backgroundColor = '#62a8ea';
        if (num === 0) {
            Obj.disabled = '';
            Obj.innerHTML = '<span>' + '重新获取' + '</span>';
            Obj.style.backgroundColor = '#4a92ff'
            clearInterval(timer)
            if (cb) {
                cb()
            }
        }
    }, 1000)
}

//分页、切换每页显示条数
const pagingFn = function (res) {
    let tempItem = {},
        data = res
    tempItem.total = data.total
    tempItem.currentPage = data.current_page
    tempItem.size = Number(data.per_page)
    if (tempItem.total > 60) {
        tempItem.sizeBox = [20, 40, 60, 100]
    } else if (tempItem.total > 40) {
        tempItem.sizeBox = [20, 40, 60]
    } else if (tempItem.total > 20) {
        tempItem.sizeBox = [20, 40]
    } else {
        tempItem.sizeBox = [20]
    }

    return tempItem
}

const verify = function (type, str) {
    let Reg = ''
    switch (type) {
        case 'zh':  // 中文
            Reg = /^[\u4E00-\u9FA5\uF900-\uFA2D]+$/
            break;
        case 'zh_en_num':
            Reg = /^[\u4e00-\u9fa5a-zA-Z0-9]{1,30}$/
            break;
        case 'class_num':
            Reg = /(^[0]{1}([.][5]{1})$)|(^[1-9]\d*([.][5]{1})?$)/
            break;
        case 'tell':
            Reg = /^(1[0-9])\d{9}$|^0\d{2,3}-?\d{7,8}$/
            break;
        case 'email': // 邮件
            Reg = /(^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+$)|(^$)/
            break;
        case 'phone': // 手机号
            Reg = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/
            break;
        case 'idCard': // 身份证号码
            Reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/
            break;
        case 'passWord': // 密码
            Reg = /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{6,20}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{6,20}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{6,20}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{6,20}$))/
            break;
        case 'bankCard': // 银行卡
            Reg = /^\d{10,30}$/
            break;
        case 'bankName': // 开户行
            Reg = /(^\s+)|(\s+$)|\s+/g
            break;
        case 'money': // 金额非0
            /* Reg = /(^[0-9]\d*([.][0-9][0-9]?)?$)/ */
            Reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^[0-9]\.[0-9]([0-9])?$)/ // 非0
            /* let Reg0 = /^(([1-9]\\d*)(\\.\\d{1,2})?|0\\.([1-9]|\\d[1-9])|0)$/ // 0,0.0,0.00*/
            if (Number(str) == 0) { return false }
            return Reg.test(str)
        case 'money0': // 金额（0）
            Reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
            break;
        default:
            console.error('不支持此类型')
    }
    return Reg.test(str)
}

//通过关键字获取常量组
const constantObj = {}
const getConstantByKeyword = function (key) {
    if (!constantObj[key]) {
        let tempConstantCacheData = store.getters['auth/constantCacheData']
        let result = {}
        switch (key) {
            case key.toUpperCase():
                result = tempConstantCacheData.constants[key].child
                break;
            case 'organization': //组织结构
                result = deepCopy(tempConstantCacheData['department'])
                break;
            case 'department': //部门
                result = tempConstantCacheData[key][0].child
                break;
            case 'channel':
                result = tempConstantCacheData[key]
                break;
            case 'filiale': //分公司
                result = deepCopy(tempConstantCacheData['department'])[0].child.filter(item => {
                    return item.dep_type == 2
                })
                break;
            case 'allSchool': //所有校区
                result = deepCopy(tempConstantCacheData['department'])[0].child.filter(item => {
                    let childItem = item.child
                    if (childItem) {
                        item.child = childItem.filter(temp => {
                            return temp.dep_type == 3
                        }).map(temp => {
                            return { dep_name: temp.dep_name, id: temp.id, dep_pid: temp.dep_pid, dep_status: temp.dep_status, status: temp.status }
                        })
                    }
                    return item.dep_type == 2
                })
                break;
            case 'bsd': //分公司校区部门
                result = deepCopy(tempConstantCacheData['department'])[0].child.filter(item => {
                    let childItem = item.child
                    if (childItem) {
                        item.child = childItem.filter(tem => {
                            return tem.dep_type == 3
                        }).map(temp => {
                            return { child: temp.child, dep_name: temp.dep_name, id: temp.id, dep_pid: temp.dep_pid, dep_status: temp.dep_status, status: temp.status }
                        })
                    }
                    return item.dep_type == 2
                })
                break;
            default:
                result = tempConstantCacheData[key]
                break;
        }
        constantObj[key] = result
    }
    return constantObj[key]
}



/*获取角色权限与常量*/
const getRoleMessAndConstant = function (roleVersion, roleMD5, consVersion, consMD5, callback) {
    let isUpdateRoleMess = roleVersion == roleMD5
    let isUpdateConstant = consVersion == consMD5
    if (isUpdateRoleMess && isUpdateConstant) {
        callback(0)
        return false
    }
    console.log(consVersion, "|||||", consMD5);
    var updateRoleMess = function () {
        return xhr.fetch(model.getUserInfo, {
            params: {
                type: 'role'
            }
        })
    }

    var updateConstant = function () {
        Object.keys(constantObj).forEach((key, index) => {
            delete constantObj[key]
        })
        Object.keys(valueToNameArr).forEach((key, index) => {
            delete constantObj[key]
        })
        return xhr.fetch(model.getMultipleConfig)
    }

    let request = [];
    !isUpdateRoleMess && request.push(updateRoleMess());
    !isUpdateConstant && request.push(updateConstant());

    Promise.all(request).then((...response) => {
        response[0].forEach(item => {
            if (item.role_permission_ids) {
                store.commit('auth/SETROLECACHE', {
                    version: roleMD5,
                    data: item
                })
            } else {
                console.log(item);
                store.commit('auth/SETCONSTANTCACHE', {
                    version: consMD5,
                    data: item
                })
            }
        })
        callback(0)
    }, data => {
        callback(1)
    })
}

const setUserAction = function (res, account) {
    store.dispatch('auth/set_user', {
        access_token: res.access_token,
        expires_in: res.expires_in,
        thisUserMess: {
            avatar: account.avatar,
            id: account.id,
            job_id: account.job_id,
            role_id: account.role_id,
            position_id: account.position_id,
            position_type: account.position_type,
            position_name: account.position_name,
            user_name: account.user_name,
            person_name: account.person_name,
            branch_id: account.branch_id,
            department_id: account.department_id,
            department_pid: account.department_pid,
            school_id: account.school_id,
            top_channel: account.top_channel,
            synch_student_its: account.synch_student_its,
            office_email: account.office_email,
            dep_property: account.dep_property || {}
        },
        workers_position_list: account.workers_position_list,
        departmentChannel: account.top_channel,
        unread_message: account.unread_message,
    })
}

/**
 * 通过关键字参数返回对应类型的时间段判断
 * @param  scopeKey
 * @return {[Number|Boolean]}
 */
const isIncludeIntra = function (scopeKey) {
    let date = new Date(),
        year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate(),
        yearQuantum = ['12-25', '1-20'],
        monthQuantum = [25, 15],
        dayQuantum = [2, 4],// 购买产品记录退费分解/续费分解时间
        dayZiZHao = [1, 1],// 自招产品购买分配/自招产品退费分配
        dayQuantum1 = [3, 5]
    switch (scopeKey) {
        case 'year':
            var startM = Number(yearQuantum[0].split('-')[0]),
                endM = Number(yearQuantum[1].split('-')[0]),
                startD = Number(yearQuantum[0].split('-')[1]),
                endD = Number(yearQuantum[1].split('-')[1])
            if ((month == startM && day >= startD) || (month > startM)) {
                return year + 1
            } else if ((month < endM) || (month == endM && day <= endD)) {
                return year
            } else {
                return false
            }
        case 'month':
            if (day >= monthQuantum[0]) {
                return month + 1
            } else if (day <= monthQuantum[1]) {
                return month
            } else {
                return false
            }
        case 'day':
            return dayZiZHao[0] <= day && dayZiZHao[1] >= day ? true : false
        case 'day_2_4':
            return dayQuantum[0] <= day && dayQuantum[1] > day ? true : false
        case 'day_3_5':
            return dayQuantum1[0] <= day && dayQuantum1[1] > day ? true : false
        default: console.error('此类型不被认可')
    }
}

const debounce = function (func, delay) { // 输入框防抖动搜索
    let timer
    return function (...args) {
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(() => {
            func.apply(this, args)
        }, delay)
    }
}

const analyticIdCard = function (idCard) {
    return {
        birth: idCard.substring(6, 10) + "-" + idCard.substring(10, 12) + "-" + idCard.substring(12, 14),
        sex: parseInt(idCard.substr(16, 1)) % 2
    }
}

/**
 * 打印页面数据
 * @param {String} content
 * @param {*} w
 * @param {*} h
 */
const print = function (content, w = null, h = null, stylesheet) {
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    w = +w === 0 ? width : w;
    h = +h === 0 ? height : h;
    const left = ((width / 2) - (w / 2)) + dualScreenLeft;
    const top = ((height / 2) - (h / 2)) + dualScreenTop;
    var myWindow = window.open("", "打印", "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
    var style = `<style type='text/css'>${stylesheet}</style>`;
    myWindow.document.write(content + style);
    myWindow.focus();
    myWindow.document.close();     //关闭document的输出流, 显示选定的数据
    myWindow.print();   //打印当前窗口
    return myWindow;
}
/**
 * 分页函数
 * @param {Array} arr
 * @param {Number} size
 */
const pageChunk = function (arr, size) {
    var newArr = []
    for (var i = 0; i < arr.length; i = i + size) {
        newArr.push(arr.slice(i, i + size))
    }
    return newArr;
}
/*
 * 判断是否为360浏览器
 */
function validate360 (option, value) {
    let mimeTypes = window.navigator.mimeTypes
    for (let mt in mimeTypes) {
        if (mimeTypes[mt][option] == value) {
            return true;
        }
    }
    return false;
}
/*
 * 获取oper浏览器版本
 */
function getOperaVersion (userAgent) {
    try {
        if (window.opera) {
            return userAgent.match(/opera.([\d.]+)/)[1];
        } else if (userAgent.indexOf("opr") > 0) {
            return userAgent.match(/opr\/([\d.]+)/)[1];
        }
    } catch (e) {
        return 0;
    }
}
/*
 * 获取IE浏览器版本
 */
function getIeVersion () {
    let IEMode = document.documentMode
    let rMsie = /(msie\s|trident.*rv:)([\w.]+)/;
    let ma = window.navigator.userAgent.toLowerCase()
    let match = rMsie.exec(ma);
    try {
        return match[2];
    } catch (e) {
        return IEMode;
    }
}
/* 浏览器信息 */
const getBrowerInfo = function () {
    let userAgent = window.navigator.userAgent.toLowerCase()
    let browserType = ''
    let browserVersion = ''
    let isIE = userAgent.match(/msie/) != null || userAgent.match(/trident/) != null
    // 浏览器类型-IE
    if (userAgent.match(/msie/) != null || userAgent.match(/trident/) != null) {
        browserType = 'IE'
        browserVersion = getIeVersion()
    }
    // 欧朋
    else if (window.opera || (userAgent.indexOf("opr") > 0)) {
        browserType = '欧朋'
        browserVersion = getOperaVersion(userAgent)
    }
    // UC
    else if (userAgent.indexOf("ubrowser") > 0) {
        browserType = 'UC'
        browserVersion = userAgent.match(/ubrowser\/([\d.]+)/)[1]
    }
    // 百度
    else if (userAgent.indexOf("bidubrowser") > 0) {
        browserType = '百度'
        browserVersion = userAgent.match(/bidubrowser\/([\d.]+)/)[1]
    }
    // 搜狗
    else if (userAgent.indexOf("metasr") > 0 || userAgent.indexOf("se 2.x") > 0) {
        browserType = '搜狗'
        // browserVersion =  userAgent.match(/metasr\/([\d.]+)/)[1]
    }
    // QQ
    else if (userAgent.indexOf("tencenttraveler") > 0) {
        browserType = 'QQ'
        browserVersion = userAgent.match(/tencenttraveler\/([\d.]+)/)[1]
    }
    // QQ
    else if (userAgent.indexOf("qqbrowser") > 0) {
        browserType = 'QQ'
        browserVersion = userAgent.match(/qqbrowser\/([\d.]+)/)[1]
    }
    // 遨游
    else if (userAgent.indexOf("maxthon") > 0) {
        browserType = '遨游'
        browserVersion = userAgent.match(/maxthon\/([\d.]+)/)[1]
    }
    // 火狐
    else if (userAgent.indexOf("firefox") > 0) {
        browserType = '火狐'
        browserVersion = userAgent.match(/firefox\/([\d.]+)/)[1]
    }
    // edge
    else if (userAgent.indexOf("edge") > 0) {
        browserType = 'Edge'
        browserVersion = userAgent.match(/edge\/([\d.]+)/)[1]
    }
    // 谷歌/360
    else if (userAgent.indexOf("chrome") > 0) {
        if (validate360('type', 'application/x360mmplugin')) {
            browserType = '360'
            // browserVersion =  userAgent.match(/chrome\/([\d.]+)/)[1]
        } else {
            browserType = '谷歌'
            browserVersion = userAgent.match(/chrome\/([\d.]+)/)[1]
        }
    }
    // 苹果
    else if (userAgent.indexOf("Safari") > -1) {
        browserType = 'Safari'
        browserVersion = userAgent.match(/version\/([\d.]+)/)[1]
    }
    return {
        browserType,
        browserVersion
    }
}

/* 大写开启 */
const isCapslock = function (e) {
    e = (e) ? e : window.event;
    var keyCode = e.keyCode || e.which; // 按键的keyCode
    var isShift = e.shiftKey || keyCode === 16 || false;// shift键是否按住
    if (((keyCode >= 65 && keyCode <= 90) && !isShift) || ((keyCode >= 97 && keyCode <= 122) && isShift)) {
        return true
    } else {
        return false
    }
}

/* 点击复制文本 */
const copyToClipboard = function (text) {
    var textArea = document.createElement("textarea");
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = '0';
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    return new Promise((resovle, reject) => {
        var successful = document.execCommand('copy');
        if (successful) {
            resovle(successful)
        } else {
            reject('该浏览器不支持点击复制到剪贴板')
        }
        document.body.removeChild(textArea);
    })
}

/**
 * 获取星期
 * @param {String} date yyyy-MM-dd
 */
const getDateDay = function (date) {
    let day = new Date(date).getDay()
    switch (day) {
        case 0: return '周日'; case 1: return '周一'; case 2: return '周二'; case 3: return '周三'; case 4: return '周四'; case 5: return '周五'; case 6: return '周六'; default: return '未知'
    }
}
/* 浮点数精度校准 */
const floatAdd = (arg1, arg2) => {
    var r1, r2, m;
    try {
        r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return (arg1 * m + arg2 * m) / m;
}
/* 获取图片的base64编码 */
const getUrlBase64 = function (imgPath, fileName) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute('crossOrigin', '');
        image.onload = function () {
            const canvas = document.createElement('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
            const ext1 = fileName.substring(0, fileName.lastIndexOf(".") - 1);
            const url = canvas.toDataURL('image/' + ext); // 得到图片的base64编码数据
            resolve({ base64: url, name: ext1 })
        };
        image.src = imgPath;
    })
}
const downLoadFile = function (imgPath, fileName) {
    getUrlBase64(imgPath, fileName).then(({ base64, name }) => {
        const a = document.createElement('a'); // 生成一个a元素
        const event = new MouseEvent('click'); // 创建一个单击事件
        a.download = name; // 设置图片名称
        a.href = base64;
        a.dispatchEvent(event);
    }, data => {

    })
}
/** 根据日期获取所在周的起止日期
 * @param {String}datevalue 日期 yyyy-MM-dd
 */
const getTimeQuantum = function (datevalue) {
    let weeks = []
    let dateValue = datevalue;
    let arr = dateValue.split("-");
    //月份-1 因为月份从0开始 构造一个Date对象
    let date = new Date(arr[0], arr[1] - 1, arr[2]);
    let dateOfWeek = date.getDay();//返回当前日期的在当前周的某一天（0～6--周日到周一）
    let dateOfWeekInt = parseInt(dateOfWeek, 10);//转换为整型
    if (dateOfWeekInt == 0) {//如果是周日
        dateOfWeekInt = 7;
    }
    let aa = 7 - dateOfWeekInt;//当前于周末相差的天数
    let temp2 = parseInt(arr[2], 10);//按10进制转换，以免遇到08和09的时候转换成0
    let sunDay = temp2 + aa;//当前日期的周日的日期
    for (let i = 0; i < 7; i++) {
        let weekDay = sunDay - (7 - i - 1);
        let weekDayDate = new Date(arr[0], arr[1] - 1, weekDay);
        let sm = parseInt(weekDayDate.getMonth()) + 1;//月份+1 因为月份从0开始
        weeks[i] = weekDayDate.getFullYear() + "-" + (sm > 9 ? sm : '0' + sm) + "-" + (weekDayDate.getDate() > 9 ? weekDayDate.getDate() : '0' + weekDayDate.getDate());
    }
    return weeks;
}

const loginUser = function () {
    return store.getters['auth/user'].thisUserMess
}
//读取cookie
const getCookie = function (name) {
    let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) return unescape(arr[2])
    return null;
}
const getDisposeSearchCriteria = function (searchJson, time, inputDate) {
    let tempSearchJson = JSON.parse(JSON.stringify(searchJson))
    Object.entries(tempSearchJson).forEach(item => {
        let key = item[0]
        let value = item[1]
        if (value === '') {
            delete tempSearchJson[key]
        }
        if (key.includes('_min')) {// 大小值范围筛选
            let m_key = key.split('_min').shift()
            tempSearchJson[m_key] = value + '_'
            delete tempSearchJson[key]
        } else
            if (key.includes('_max')) {// 大小值范围筛选
                let m_key = key.split('_max').shift()
                tempSearchJson[m_key] = tempSearchJson[m_key] ? (tempSearchJson[m_key] + value) : (0 + '_' + value)
                delete tempSearchJson[key]
            } else
                /**时间筛选 [key]_start_[keyType]
                 * @param key 拼接字段前缀
                 * @param keyType 拼接字段后缀 ['date','time']
                 */
                if (key.includes('time_')) {// time_ 类型
                    if (value && typeof value === 'object' && value.length) {
                        let m_key = key.split('time_').pop()
                        tempSearchJson[m_key + '_start_time'] = value[0]
                        tempSearchJson[m_key + '_end_time'] = value[1]
                        delete tempSearchJson[key]
                    }
                } else
                    if (key.includes('date_')) {// date_ 类型
                        if (value && typeof value === 'object' && value.length) {
                            let m_key = key.split('date_').pop()
                            tempSearchJson[m_key + '_start_date'] = value[0]
                            tempSearchJson[m_key + '_end_date'] = value[1]
                            delete tempSearchJson[key]
                        }
                    } else
                        if (key.includes('_date') || key.includes('_time')) {// 处理时间
                            if (value && typeof value === 'object' && value.length) {
                                tempSearchJson[key] = value.join('_')
                            } else {
                                tempSearchJson[key] = value || ''
                            }
                        } else {
                            if (value && typeof value === 'object') {
                                if (value.length) {
                                    tempSearchJson[key] = value[value.length - 1]
                                } else {
                                    tempSearchJson[key] = value || ''
                                }
                            }
                        }
    })
    if (!time) {
        let dateRange = inputDate
        if (dateRange && dateRange.length) {
            tempSearchJson['start_time'] = dateRange[0] || ''
            tempSearchJson['end_time'] = dateRange[1] || ''
        }
    }
    return tempSearchJson
}

export {
    bus,
    downLoadFile,
    each,
    merge,
    formatDate,
    setStore,
    getStore,
    clearStore,
    delItem,
    getUpdateUrl,
    getExcelUrl,
    isEmptyObject,
    pickerAfterToday,
    getAction,
    getActions,
    getRole_permission,
    getRole_route,
    getAccess_token,
    getDepartmentChannel,
    deepCopy,
    valueToName,
    getToken,
    codeCountdown,
    getRoleMessAndConstant,
    setUserAction,
    pagingFn,
    verify,
    getConstantByKeyword,
    isIncludeIntra,
    firstCurDate,
    dateTypeValue,
    debounce,
    analyticIdCard,
    print,
    pageChunk,
    getBrowerInfo,
    isCapslock,
    timer,
    copyToClipboard,
    getDateDay,
    floatAdd,
    treeToList,
    getTimeQuantum,
    loginUser,
    getCookie,
    setCookie,
    clearCookie,
    getDisposeSearchCriteria
}



// WEBPACK FOOTER //
// ./src/service/utils.js